// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"b77dc2db793dc78df4c1","532":"607dbc2c8dbc943aadac","678":"0da9faa16018f7811663","883":"26929e216df24f4b097c","954":"d04aca96fe8d9472f1cd"}[chunkId] + ".js";
};